import { ArrowRight, Flame } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * PIELiveCounterStrip — a thin, glanceable status row pinned under the
 * Individual Focus tile's CTAs when PIE is healthy. Three counters
 * (personas / showcases / closed-this-week) plus a passive engagement
 * nudge when there's at least 1 commitment closed in the last 7 days.
 *
 * Clicking the strip jumps to the Validate page where the closed
 * commitments live — it's a soft pull, not a hard pitch.
 */
export function PIELiveCounterStrip({ stats, onClick }) {
  const total = stats.personas_total || 0;
  const showcases = stats.showcase_count || 0;
  const closed = stats.commitments_validated_this_week || 0;
  const active = stats.commitments_active || 0;

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'mt-3 w-full flex items-center gap-4 px-3 py-2 rounded-lg text-left transition-colors',
        'bg-violet-50 hover:bg-violet-100 border border-violet-100',
      )}
      data-testid="lie-pie-live-counter"
    >
      <div className="flex items-center gap-1.5 min-w-0">
        <span className="text-[10px] uppercase tracking-wider text-violet-700 font-bold">
          Live
        </span>
      </div>
      <div className="flex items-center gap-3 flex-wrap text-[11px] text-slate-600 flex-1 min-w-0">
        <span data-testid="lie-pie-counter-personas">
          <strong className="text-slate-800">{total}</strong> personas
        </span>
        <span className="text-slate-300">·</span>
        <span data-testid="lie-pie-counter-showcases">
          <strong className="text-slate-800">{showcases}</strong> showcase
        </span>
        {active > 0 && (
          <>
            <span className="text-slate-300">·</span>
            <span data-testid="lie-pie-counter-active">
              <strong className="text-slate-800">{active}</strong> active commitment{active === 1 ? '' : 's'}
            </span>
          </>
        )}
        {closed > 0 && (
          <>
            <span className="text-slate-300">·</span>
            <span
              className="text-emerald-700 font-medium inline-flex items-center gap-1"
              data-testid="lie-pie-counter-closed"
            >
              <Flame className="h-3 w-3" />
              <strong>{closed}</strong> closed this week — see who
            </span>
          </>
        )}
      </div>
      <ArrowRight className="h-3.5 w-3.5 text-violet-400 flex-shrink-0" />
    </button>
  );
}
